import { Sort as Sort_kojaro } from './Sort.kojaro';
import { Sort as Sort_phosphor } from './Sort.phosphor';
import { Sort as Sort_zoomg } from './Sort.zoomg';
import { Sort as Sort_zoomit } from './Sort.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Sort_kojaro;

    case 'zoomg':
      return Sort_zoomg;

    case 'phosphor':
      return Sort_phosphor;

    default:
      return Sort_zoomit;
  }
};

export const Sort = IconRenderer();
